import { render, staticRenderFns } from "./ClinicianPatientAlertTable.vue?vue&type=template&id=2e46efa0"
import script from "./ClinicianPatientAlertTable.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientAlertTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports